// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignupSettingsForm-containerWith-Ui8jS {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.SignupSettingsForm-container-OsLyv {
    max-width: 100%;
}

/* Text - Start */

.SignupSettingsForm-subText-lewks {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.SignupSettingsForm-navigationLink-ZsGe1 a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.SignupSettingsForm-navigationLink-ZsGe1 a:hover,
.SignupSettingsForm-navigationLink-ZsGe1 a:focus,
.SignupSettingsForm-navigationLink-ZsGe1 a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.SignupSettingsForm-noPadding-s_Mgf {
    padding: 0;
}

.SignupSettingsForm-heading-nNfnH {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.SignupSettingsForm-widthInner-Skmci {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.SignupSettingsForm-noMargin-R87XP {
    margin: 0;
}

.SignupSettingsForm-formControlInputTable-Xv9uN {
    border: none;
    width: 100px;
    height: auto;
}

.SignupSettingsForm-backBtn-vmKPC {
    margin-left: 15px;
    display: inline-block;
}

.SignupSettingsForm-backBtn-vmKPC:active,
.SignupSettingsForm-backBtn-vmKPC:hover,
.SignupSettingsForm-backBtn-vmKPC:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.SignupSettingsForm-textAlignRight-dMX_0 {
    text-align: right;
}

.SignupSettingsForm-displayInlineBlock-lYPF2 {
    display: inline-block;
}

.SignupSettingsForm-displayBlock-N_OI1 {
    display: block;
}

.SignupSettingsForm-countryCode-LxIEK {
    width: 15%;
    vertical-align: top;
}

.SignupSettingsForm-vtrMiddle-fmlHs {
    vertical-align: middle;
}

/* commonCss */

.SignupSettingsForm-editIcon-BCYRY {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.SignupSettingsForm-iconBtn-fDcAC,
.SignupSettingsForm-iconBtn-fDcAC:hover,
.SignupSettingsForm-iconBtn-fDcAC:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.SignupSettingsForm-profileImg-d0pQ1 {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.SignupSettingsForm-profileImgSection-Ks2eG {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.SignupSettingsForm-profileImgWidth-ZbTuP {
    margin: 0;
    max-width: 100% !important;
}

.SignupSettingsForm-searchInput-Lg1Yi {
    width: 100%;
    max-width: 320px;
}

.SignupSettingsForm-backgroundImg-B0FlA {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.SignupSettingsForm-exportDisplay-H6xmH {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.SignupSettingsForm-exportTextSection-LKUyO {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.SignupSettingsForm-exportText-LUAHd {
    display: inline-block;
    padding-right: 5px;
}

.SignupSettingsForm-exportTextContainer-LOYZu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.SignupSettingsForm-vtrTextBottom-oqOsv {
    vertical-align: text-bottom;
}

.SignupSettingsForm-exportImg-ay1z9 {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.SignupSettingsForm-noLink-htwiG,
.SignupSettingsForm-noLink-htwiG:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.SignupSettingsForm-singleCard-aB3Ps {
    width: 500px;
    margin: 0 auto;
}

.SignupSettingsForm-defaultIcon-vJpj2 {
    background-size: 50px;
}

.SignupSettingsForm-assignProviderSearchInput-SDIdE {
    width: 100%;
    max-width: 324px;
}

.SignupSettingsForm-searchGroupContainer-Pjkke {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .SignupSettingsForm-searchGroupContainer-Pjkke {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .SignupSettingsForm-widthInner-Skmci {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .SignupSettingsForm-aboutGrid-vdk5w img {
    position: relative;
    top: -25px !important;
  }

  .SignupSettingsForm-responsiveView-F61yO {
    width: 100% !important;
    max-width: 175px !important;
  }

  .SignupSettingsForm-positionFive-NmHK8 {
    top: 28% !important;
  }

  .SignupSettingsForm-positionTwo-rZph9 {
    top: 28% !important;
  }

  .SignupSettingsForm-responsiveContentOne-SvEn4 {
    top: -50px !important;
  }

  .SignupSettingsForm-positionFour-WoXqG {
    top: -50px !important;
  }

  .SignupSettingsForm-totalCss-rFhAK {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .SignupSettingsForm-navbar-expand-lg-Wn_WK .SignupSettingsForm-navbar-toggler-fYQxs {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .SignupSettingsForm-profileImgSection-Ks2eG {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .SignupSettingsForm-navigationLink-ZsGe1 a {
    color: var(--primary-foreground) !important;
  }

  .SignupSettingsForm-widthInner-Skmci {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .SignupSettingsForm-responsiveContentOne-SvEn4 {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .SignupSettingsForm-positionTwo-rZph9 {
    top: 24% !important;
    left: -5% !important;
  }

  .SignupSettingsForm-positionThree-_e_nd {
    top: 70% !important;
    left: -5% !important;
  }

  .SignupSettingsForm-positionFour-WoXqG {
    top: -42px !important;
    right: -5% !important;
  }

  .SignupSettingsForm-positionFive-NmHK8 {
    top: 20% !important;
    right: -5% !important;
  }

  .SignupSettingsForm-positionSix-zuIR_ {
    top: 70% !important;
    right: -5% !important;
  }

  .SignupSettingsForm-responsiveView-F61yO {
    width: 100% !important;
    max-width: 115px !important;
  }

  .SignupSettingsForm-aboutGrid-vdk5w img {
    top: -1px !important;
  }

  .SignupSettingsForm-contentOne-ehokf h1 {
    font-size: 16px !important;
  }

  .SignupSettingsForm-contentOne-ehokf p {
    font-size: 12px !important;
  }


  .SignupSettingsForm-totalCss-rFhAK {
    width: 100% !important;
  }

  .SignupSettingsForm-padding-Tmuxt {
    padding: 0px 0 0 60px !important;
  }

  .SignupSettingsForm-singleCard-aB3Ps {
    width: 100% !important;
  }

  .SignupSettingsForm-navigationLink-ZsGe1 a:hover,
  .SignupSettingsForm-navigationLink-ZsGe1 a:focus,
  .SignupSettingsForm-navigationLink-ZsGe1 a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .SignupSettingsForm-navbar-collapse-ll_oX.SignupSettingsForm-show-_Aea7 {
    right: 0% !important;
    top: 0 !important;
  }

  .SignupSettingsForm-navbar-collapse-ll_oX {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .SignupSettingsForm-content-wPv5S {
    float: none;
  }

  .SignupSettingsForm-mr-auto-rY4VQ.SignupSettingsForm-navbar-nav-b9MGi {
    padding-bottom: 80px !important;
  }

  .SignupSettingsForm-navigationLink-ZsGe1 a {
    color: var(--primary-foreground) !important;
  }

  .SignupSettingsForm-footer-c9ygk {
    padding: 35px 0 0 15px;
  }

  .SignupSettingsForm-widthInner-Skmci {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .SignupSettingsForm-responsiveNoPadding-JzpB2 {
    padding: 0px !important;
  }

  .SignupSettingsForm-contentOne-ehokf {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .SignupSettingsForm-aboutContainer-JBbtP {
    padding: 30px 0 30px !important;
  }

  .SignupSettingsForm-noPosition-ADYhC {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .SignupSettingsForm-mobimleImg-g3RdM {
    display: none !important;
  }

  .SignupSettingsForm-totalCss-rFhAK {
    width: 100% !important;
  }

  .SignupSettingsForm-imgWidth-gb_4X {
    padding: 18px !important;
  }

  .SignupSettingsForm-searchInput-Lg1Yi,
  .SignupSettingsForm-assignProviderSearchInput-SDIdE {
    max-width: 100% !important;
  }

  .SignupSettingsForm-exportText-LUAHd {
    display: inline-block;
  }

  .SignupSettingsForm-gridSystem-_zQTU {
    grid-template-columns: auto !important;
  }

  .SignupSettingsForm-padding-Tmuxt {
    padding: 52px 0 0 0 !important;
  }

  .SignupSettingsForm-heading-nNfnH {
    padding: 30px 0 24px !important;
  }

  .SignupSettingsForm-singleCard-aB3Ps {
    width: 100% !important;
  }

  .SignupSettingsForm-displayGrid-xZknO {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .SignupSettingsForm-boxInner-ZDPVH {
    padding: 35px 0 !important;
  }

  .SignupSettingsForm-navigationLink-ZsGe1 a:hover,
  .SignupSettingsForm-navigationLink-ZsGe1 a:focus,
  .SignupSettingsForm-navigationLink-ZsGe1 a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .SignupSettingsForm-whiteDropdown-lEqk2 select {
    width: 120px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `SignupSettingsForm-containerWith-Ui8jS`,
	"container": `SignupSettingsForm-container-OsLyv`,
	"subText": `SignupSettingsForm-subText-lewks`,
	"navigationLink": `SignupSettingsForm-navigationLink-ZsGe1`,
	"noPadding": `SignupSettingsForm-noPadding-s_Mgf`,
	"heading": `SignupSettingsForm-heading-nNfnH`,
	"widthInner": `SignupSettingsForm-widthInner-Skmci`,
	"noMargin": `SignupSettingsForm-noMargin-R87XP`,
	"formControlInputTable": `SignupSettingsForm-formControlInputTable-Xv9uN`,
	"backBtn": `SignupSettingsForm-backBtn-vmKPC`,
	"textAlignRight": `SignupSettingsForm-textAlignRight-dMX_0`,
	"displayInlineBlock": `SignupSettingsForm-displayInlineBlock-lYPF2`,
	"displayBlock": `SignupSettingsForm-displayBlock-N_OI1`,
	"countryCode": `SignupSettingsForm-countryCode-LxIEK`,
	"vtrMiddle": `SignupSettingsForm-vtrMiddle-fmlHs`,
	"editIcon": `SignupSettingsForm-editIcon-BCYRY`,
	"iconBtn": `SignupSettingsForm-iconBtn-fDcAC`,
	"profileImg": `SignupSettingsForm-profileImg-d0pQ1`,
	"profileImgSection": `SignupSettingsForm-profileImgSection-Ks2eG`,
	"profileImgWidth": `SignupSettingsForm-profileImgWidth-ZbTuP`,
	"searchInput": `SignupSettingsForm-searchInput-Lg1Yi`,
	"backgroundImg": `SignupSettingsForm-backgroundImg-B0FlA`,
	"exportDisplay": `SignupSettingsForm-exportDisplay-H6xmH`,
	"exportTextSection": `SignupSettingsForm-exportTextSection-LKUyO`,
	"exportText": `SignupSettingsForm-exportText-LUAHd`,
	"exportTextContainer": `SignupSettingsForm-exportTextContainer-LOYZu`,
	"vtrTextBottom": `SignupSettingsForm-vtrTextBottom-oqOsv`,
	"exportImg": `SignupSettingsForm-exportImg-ay1z9`,
	"noLink": `SignupSettingsForm-noLink-htwiG`,
	"singleCard": `SignupSettingsForm-singleCard-aB3Ps`,
	"defaultIcon": `SignupSettingsForm-defaultIcon-vJpj2`,
	"assignProviderSearchInput": `SignupSettingsForm-assignProviderSearchInput-SDIdE`,
	"searchGroupContainer": `SignupSettingsForm-searchGroupContainer-Pjkke`,
	"aboutGrid": `SignupSettingsForm-aboutGrid-vdk5w`,
	"responsiveView": `SignupSettingsForm-responsiveView-F61yO`,
	"positionFive": `SignupSettingsForm-positionFive-NmHK8`,
	"positionTwo": `SignupSettingsForm-positionTwo-rZph9`,
	"responsiveContentOne": `SignupSettingsForm-responsiveContentOne-SvEn4`,
	"positionFour": `SignupSettingsForm-positionFour-WoXqG`,
	"totalCss": `SignupSettingsForm-totalCss-rFhAK`,
	"navbar-expand-lg": `SignupSettingsForm-navbar-expand-lg-Wn_WK`,
	"navbar-toggler": `SignupSettingsForm-navbar-toggler-fYQxs`,
	"positionThree": `SignupSettingsForm-positionThree-_e_nd`,
	"positionSix": `SignupSettingsForm-positionSix-zuIR_`,
	"contentOne": `SignupSettingsForm-contentOne-ehokf`,
	"padding": `SignupSettingsForm-padding-Tmuxt`,
	"navbar-collapse": `SignupSettingsForm-navbar-collapse-ll_oX`,
	"show": `SignupSettingsForm-show-_Aea7`,
	"content": `SignupSettingsForm-content-wPv5S`,
	"mr-auto": `SignupSettingsForm-mr-auto-rY4VQ`,
	"navbar-nav": `SignupSettingsForm-navbar-nav-b9MGi`,
	"footer": `SignupSettingsForm-footer-c9ygk`,
	"responsiveNoPadding": `SignupSettingsForm-responsiveNoPadding-JzpB2`,
	"aboutContainer": `SignupSettingsForm-aboutContainer-JBbtP`,
	"noPosition": `SignupSettingsForm-noPosition-ADYhC`,
	"mobimleImg": `SignupSettingsForm-mobimleImg-g3RdM`,
	"imgWidth": `SignupSettingsForm-imgWidth-gb_4X`,
	"gridSystem": `SignupSettingsForm-gridSystem-_zQTU`,
	"displayGrid": `SignupSettingsForm-displayGrid-xZknO`,
	"boxInner": `SignupSettingsForm-boxInner-ZDPVH`,
	"whiteDropdown": `SignupSettingsForm-whiteDropdown-lEqk2`
};
module.exports = ___CSS_LOADER_EXPORT___;
